import Config from "../config";
import axios from "axios";

type ApiResult<T> = { success: boolean; data: T | null; error: any };

const getApiError = (error: any): any => error.response?.data ?? error.message;

//region Partners
export const fetchPartnerConfiguration = async (partnerId: number | string): Promise<ApiResult<any>> => {
    const url = Config.api + `/odata/Company/PartnershipConfigurationProperty?$filter=(PartnerCoId eq ${partnerId} or CoId eq ${partnerId})`;

    try {
        const configProperties = await axios.get(url);
        return {
            success: true,
            data: configProperties.data.value,
            error: null
        }
    }
    catch (error: any) {
        return {
            success: false,
            data: null,
            error: getApiError(error)
        }
    }
}
export const fetchCompanyProfile = async (): Promise<ApiResult<any>> => {
    const url = Config.api + `/api/v2/Partners/CompanyProfile`;

    try {
        const response = await axios.get(url);
        return {
            success: true,
            data: response.data,
            error: null
        }
    }
    catch (error: any) {
        return {
            success: false,
            data: null,
            error: getApiError(error)
        }
    }
}

export const fetchPartnerCompanyProfile = async (partnerId: number | string): Promise<ApiResult<any>> => {
    const url = Config.api + `/api/v2/Partners/CompanyProfile/${partnerId}`;

    try {
        const response = await axios.get(url);
        return {
            success: true,
            data: response.data,
            error: null
        }
    }
    catch (error: any) {
        return {
            success: false,
            data: null,
            error: getApiError(error)
        }
    }
}

export const putCompanyProfile = async (data: any): Promise<ApiResult<any>> => {
    const url = Config.api + `/api/v2/Partners/CompanyProfile`;

    try {
        const response = await axios.put(url, data);
        return {
            success: true,
            data: response.data,
            error: null
        }
    }
    catch (error: any) {
        return {
            success: false,
            data: null,
            error: getApiError(error)
        }
    }
}
//endregion
